import { objectPlantInfo } from './../models/plant';
import { inverterInfo, ListResponse, plantInfo, plantItem, maintenance } from '../models';
import { ListParams, ResponseData } from './../models/common';
import axiosClient from './axiosClient';

const urlApi = '/api/v1/plant';
export const plantApi = {
  getPlantsList(param: ListParams): Promise<ListResponse<plantInfo>> {
    let url = `${urlApi}-list?page_size=${param.page_size}&page=${param.page}&search_label=${param.text}`;
    return axiosClient.get(url);
  },
  getPlantsByUserId(id: string): Promise<ListResponse<plantInfo>> {
    const url = `api/v1/sidebar?user_id=${id}`;
    return axiosClient.get(url);
  },
  getInvertersByUserId(param: ListParams): Promise<ListResponse<inverterInfo>> {
    const url = `${urlApi}/${param.type}=${param.id}&page_size=${param.page_size}&page=${param.page}`;
    return axiosClient.get(url);
  },
  fetchInfoPropertiesEnergy(param: ListParams): Promise<ResponseData[]> {
    const url = `${urlApi}-dashboard/${param.type}/${param.properties}?plant_id=${param.id}&date=${param.time}`;
    return axiosClient.get(url);
  },
  fetchPlantInfo(param: ListParams): Promise<plantInfo> {
    const url = `${urlApi}?${param.type}=${param.id}`;
    return axiosClient.get(url);
  },
  fetchElectricityPrice(param: ListParams): Promise<objectPlantInfo> {
    const url = `${urlApi}/${param.type}?plant_id=${param.id}`;
    return axiosClient.get(url);
  },
  fetchMaintenanceInfo(param: ListParams): Promise<maintenance> {
    const url = `${urlApi}/${param.type}?plant_id=${param.id}`;
    return axiosClient.get(url);
  },
  fetchMaintenanceList(param: ListParams): Promise<maintenance[]> {
    const url = `${urlApi}/${param.type}?plant_id=${param.id}&start_ts=${param.start_time}&end_ts=${param.end_time}&limit=100&order=DESC`;
    return axiosClient.get(url);
  },
  add(data: plantItem): Promise<plantInfo> {
    const url = `${urlApi}`;
    return axiosClient.post(url, data);
  },
  addMaintenance(param: ListParams): Promise<maintenance> {
    const url = `${urlApi}/${param.type}?plant_id=${param.id}`;
    return axiosClient.post(url, param.newMaintenance);
  },
  update(data: Partial<plantInfo>): Promise<plantInfo> {
    const url = `${urlApi}?plant_id=${data.id}`;
    return axiosClient.put(url, data);
  },
  updateMaintenance(param: ListParams): Promise<maintenance> {
    const url = `${urlApi}/${param.type}?plant_id=${param.id}`;
    return axiosClient.put(url, param.editMaintenance);
  },
  editElectricityPrice(param: ListParams): Promise<objectPlantInfo> {
    const url = `${urlApi}/${param.type}/${param.id}`;
    return axiosClient.put(url, { electricity_price: param.electricity_price });
  },
  remove(id: string): Promise<any> {
    const url = `${urlApi}?plant_id=${id}`;
    return axiosClient.delete(url);
  },

  fetchLatestTimeSeries(param: ListParams): Promise<objectPlantInfo> {
    const url = `${urlApi}-dashboard/${param.type}?plant_id=${param.id}`;
    return axiosClient.get(url);
  },

  fetchPropertiesPlant(param: ListParams): Promise<ResponseData[]> {
    const url = `${urlApi}-dashboard/${param.type}?plant_id=${param.id}&date=${param.time}`;
    return axiosClient.get(url);
  },
};
